/**
 * Chain Option is now a native <select> dropdown on desktop instead of the
 * custom clickable box (Material and Purity keeps the boxes).
 *
 * The custom picker boxes (assets/craft-picker.css .kg-craft-picker) still
 * exist in the DOM (just hidden for Chain Option) because swatch.liquid's own
 * script reads each picker's ".active" item to compute per-option prices
 * (e.g. the price shown next to each gold purity choice). Since the user no
 * longer clicks that hidden box, we mirror the dropdown's selection onto it
 * here so those price calculations keep reflecting the real chain length.
 */
(function () {
  'use strict';

  function labelMatches(labelEl, name) {
    if (!labelEl) return false;
    return labelEl.textContent.trim().toUpperCase() === name.trim().toUpperCase();
  }

  function syncHiddenPicker(select, optionName) {
    var pickers = document.querySelectorAll('.kg-craft-picker');
    for (var i = 0; i < pickers.length; i++) {
      var picker = pickers[i];
      var label = picker.querySelector('.kg-craft-picker__label');
      if (!labelMatches(label, optionName)) continue;

      var items = picker.querySelectorAll('.kg-craft-picker__item');
      items.forEach(function (item) {
        var isMatch = item.getAttribute('data-value') === select.value;
        item.classList.toggle('active', isMatch);
      });
    }
  }

  function bind(wrap) {
    if (wrap._chainDropdownBound) return;
    wrap._chainDropdownBound = true;

    var select = wrap.querySelector('select.single-option-selector');
    if (!select) return;

    var optionName = wrap.getAttribute('data-option-name') || '';

    select.addEventListener('change', function () {
      syncHiddenPicker(select, optionName);
    });

    // Keep it correct on initial load too.
    syncHiddenPicker(select, optionName);
  }

  /*
   * (The "SOLID GOLD" badge used to be moved by this script next to the
   * "MATERIAL AND PURITY" heading. It now stays in the delivery block
   * (.shippingMsg) and is placed on its own line below "Estimated
   * delivery" purely with CSS in craft-spacing.css, so no script is
   * needed for it any more.)
   */

  /**
   * Desktop sticky product image (.product-single .pr_photoes is set to
   * position:sticky in craft-spacing.css). Sticky positioning silently stops
   * working when any element above it - including <body> and <html> - has
   * overflow:hidden, because that element becomes its own non-scrolling
   * scroll container. On desktop only, every such element between the
   * image column and the top of the page is switched to overflow:clip: it
   * still clips (and still blocks page scrolling when used as a scroll
   * lock), but it doesn't create a scroll container, so sticky keeps
   * working. Wrappers that genuinely scroll (auto/scroll) are untouched.
   *
   * Popups (e.g. the 5% newsletter popup) lock page scrolling by setting
   * overflow:hidden on <html>/<body> and don't fully restore the original
   * values when they close, which broke the sticky image afterwards. So
   * this re-runs whenever <html> or <body> classes/styles change, and
   * whenever the window is resized across the desktop breakpoint.
   */
  var stickyMQ = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;

  function enableStickyGallery() {
    if (!stickyMQ || !stickyMQ.matches) return;
    var col = document.querySelector('.product-single .pr_photoes');
    if (!col) return;
    var el = col.parentElement;
    while (el) {
      var cs = getComputedStyle(el);
      if (cs.overflowX === 'hidden') el.style.setProperty('overflow-x', 'clip', 'important');
      if (cs.overflowY === 'hidden') el.style.setProperty('overflow-y', 'clip', 'important');
      el = el.parentElement;
    }
  }

  function watchStickyGallery() {
    if (!document.querySelector('.product-single .pr_photoes')) return;
    enableStickyGallery();
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      (window.requestAnimationFrame || setTimeout)(function () {
        pending = false;
        enableStickyGallery();
      });
    }
    if (window.MutationObserver) {
      var obs = new MutationObserver(schedule);
      var opts = { attributes: true, attributeFilter: ['class', 'style'] };
      obs.observe(document.documentElement, opts);
      obs.observe(document.body, opts);
    }
    if (stickyMQ && stickyMQ.addEventListener) stickyMQ.addEventListener('change', schedule);
    window.addEventListener('load', schedule);
  }

  /**
   * Desktop only (768px+): the sticky Add to Cart bar (.craft-sticky-cart,
   * built in sections/main-product.liquid) appears once the visitor has
   * scrolled 60% of the way down the page, instead of as soon as the main
   * Add to Cart button scrolls out of view. It still hides again in the
   * last 200px of the page (same as before) and stays hidden once closed
   * with its X. Phones keep the section's original behaviour.
   *
   * The section's own scroll handler still runs; this one is registered
   * after it, so on desktop it has the final say on the bar's
   * "is-visible" class on every scroll.
   */
  var STICKY_CART_SCROLL = 0.60;

  function watchStickyCartDesktop() {
    var bar = document.querySelector('.craft-sticky-cart');
    if (!bar || !stickyMQ) return;
    var dismissed = false;
    var closeEl = bar.querySelector('.craft-sticky-cart__close');
    if (closeEl) closeEl.addEventListener('click', function () { dismissed = true; });

    function apply() {
      if (!stickyMQ.matches) return;
      var doc = document.documentElement;
      var scrollY = window.pageYOffset || doc.scrollTop || 0;
      var max = Math.max(doc.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      var progress = max > 0 ? scrollY / max : 0;
      var nearBottom = (window.innerHeight + scrollY) >= document.body.offsetHeight - 200;
      var show = !dismissed && progress >= STICKY_CART_SCROLL && !nearBottom;
      bar.classList.toggle('is-visible', show);
    }

    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
    if (stickyMQ.addEventListener) stickyMQ.addEventListener('change', apply);
    apply();
  }

  function init() {
    document.querySelectorAll('.dd_wrap[data-option-handle="chain-option"]').forEach(bind);
    watchStickyGallery();
    watchStickyCartDesktop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
